import { BlogSectionType } from '../../../models/Content';

export const transformSectionNote = (content: BlogSectionType) => {
    return {
        title: content.fields.title,
        text: content.fields.text,
    };
};
